import React from "react"
import { Paper, Stack } from "@mui/material";
import { styled } from "@mui/material";
import Divider from '@mui/material/Divider';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body1,
    padding: theme.spacing(0, 0, 0, 4),
    textAlign: 'left',
    color: theme.palette.text.primary,
    boxShadow: 'none'
}));

const DetailList = (props) => {
  const { listItems, numbered, spacing } = props
  
  return (
    <Stack spacing={spacing} paddingBottom={4}>
      {listItems.map((item, index) => (
        <React.Fragment key={index}>
            <Item>{numbered ? `${index + 1}. ${item}` : item}</Item>
            {index !== listItems.length - 1 && <Divider />}
        </React.Fragment>
      ))}
    </Stack>
  );
}

export default DetailList
